interface Prices {
	standardPrice: number;
	premiumPrice: number;
}

/**
 * Returns the <=100 user tier per-user-per-month prices for Standard and Premium editions of
 * Confluence.
 */
export const usePricing = (): Prices => {
	// For now, this returns hardcoded prices sourced from:
	// https://www.atlassian.com/software/confluence/pricing (set team size to 99 users)
	return {
		standardPrice: 6.05,
		premiumPrice: 11.55,
	};
};
